import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { EnterIcon, ChevronLeftIcon } from "@radix-ui/react-icons";
import { Button, Card, Flex, Spinner, Text } from "@radix-ui/themes";
import toast from "react-hot-toast";

import { StudentSituationType } from "../../types/StudentSituation";
import { useAppDispatch } from "../../hooks/hooks";
import { updateStudentSituation } from "../../services/school/studentSituation";
import { routes } from "../../routes";
import { StudentSituationFormValidation } from "./StudentSituationFormValidation";
import TextFieldComponent from "../../components/inputs/Textfield/TextfieldComponent";
import { RootState } from "../../redux/store";
import { resetStudentSituationData, setStudentSituationData } from "../../redux/slices/school/studentSituation";
import RadioGroupComponent from "../../components/inputs/RadioGroup/RadioGroupComponent";
import TextAreaFieldComponent from "../../components/inputs/TextAreafield/TextAreafieldComponent";
import { setPdfPreviewType } from "../../redux/slices/report/report";
import { getStudentById } from "../../services/school/student/getStudentByCode";
import { setUserData } from "../../redux/slices/users/user";
import { setStudentData } from "../../redux/slices/school/student";
import { getUserById } from "../../services/user/getUsers";

export const UpdateStudentSituation = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const studentSituationData = useSelector(
    (state: RootState) => state.studentSituation
  );
  console.log({ studentSituationData })

  const mutationUpdate = useMutation({ mutationFn: updateStudentSituation, mutationKey: "updateStudentSituation" });

  const { control, handleSubmit, formState: { errors }, reset } = useForm<StudentSituationType>({
    resolver: yupResolver(StudentSituationFormValidation),
    defaultValues: studentSituationData,
    mode: "onBlur",
  });

  useEffect(() => {
    if (!studentSituationData.id) {
      navigate(routes.studentSituations);
    }
  }, [studentSituationData, navigate]);

  const onSubmit = handleSubmit(async (data) => {
    try {
      await mutationUpdate.mutateAsync(data);
      toast.success("Situação actualizada com sucesso!");
      try {
          const studentData = await getStudentById(data.idStudent);
                const userData = await getUserById(studentData.idUser);
              dispatch(setUserData(userData as any))
                dispatch(setStudentData(studentData))
      } catch (error) {
        console.log("error", error);
        toast.error("Estudante não encontrado!");
        return;
      }
        dispatch(setStudentSituationData(data));
        dispatch(setPdfPreviewType('STUDENT_SITUATION'));
        navigate(routes.pdfPreview);
    } catch (err: any) {
      toast.error(err?.message || "Erro ao actualizar situação");
    }
  });

  const handleBack = () => {
    dispatch(resetStudentSituationData());
    navigate(routes.createStudentSituation);
  };
  console.log({ errors })
  return (
    <Card size="5">
      <Flex direction="column" gap="6">
        <Text size="4" weight="bold">Editar Situação do Estudante</Text>
        <form onSubmit={onSubmit} noValidate>
          <Card size="1">
            <Flex direction="column" gap="4">
              <TextFieldComponent name="internalCode" label="Código interno" control={control} errors={errors} required={true}  />
              <TextAreaFieldComponent name="description" label="Descrição" control={control} errors={errors} required={true} />
              <TextAreaFieldComponent name="problem" label="Problema" control={control} errors={errors} />
              <TextAreaFieldComponent name="soluction" label="Solução" control={control} errors={errors} />
              <TextAreaFieldComponent name="reason" label="Motivo" control={control} errors={errors} />
              <RadioGroupComponent
                name="isResolved"
                label="A situação foi resolvida?"
                control={control}
                errors={errors}
                options={[
                  { value: "true", label: "Sim" },
                  { value: "false", label: "Não" },
                ]}
              />
              <Flex direction="row" gap="4" style={{ alignSelf: "end" }}>
                <Button type="button" variant="soft" color="gray" onClick={handleBack} disabled={mutationUpdate.isLoading}>
                  <ChevronLeftIcon /> Voltar
                </Button>
                <Button type="submit" disabled={mutationUpdate.isLoading} variant="surface">
                  {mutationUpdate.isLoading ? <Spinner loading> <EnterIcon /></Spinner> : <EnterIcon />}
                  Actualizar
                </Button>
              </Flex>
            </Flex>
          </Card>
        </form>
      </Flex>
    </Card>
  );
};

